import { withRouter } from 'react-router';
import { compose, branch, renderNothing } from 'recompose';

const checkIfWebNotification = ({ location: { pathname } }) => /brands\/\S+\/notifications/.test(pathname);

const preventRenderForWebNotifications = compose(
  withRouter,
  branch(
    checkIfWebNotification,
    renderNothing,
  )
);

export default preventRenderForWebNotifications;



// WEBPACK FOOTER //
// ./src/app/hoc/preventRenderForWebNotifications.js